import { useState } from "react"
import BuyerCampaignTemplates from "components/buyerCampaigns/BuyerCampaignTemplates"
import BuyerCampaigns from "components/buyerCampaigns/BuyerCampaigns"
import {
  useGetBuyerCampaignTemplates,
  useGetBuyerCampaigns,
} from "apis/buyerCampaign"
import PageLoader from "components/ui/PageLoader"

const BuyerCampaignManagement = () => {
  const [activeTab, setActiveTab] = useState("templates")

  const {
    data: templates,
    isPending: isTemplatesLoading,
    isError: isTemplatesError,
  } = useGetBuyerCampaignTemplates()

  const {
    data: campaigns,
    isPending: isCampaignsLoading,
    isError: isCampaignsError,
  } = useGetBuyerCampaigns()

  if (isTemplatesLoading || isCampaignsLoading) {
    return <PageLoader />
  }

  if (isTemplatesError || isCampaignsError) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="bg-red-50 p-4 rounded-md">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
                  clipRule="evenodd"
                />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">
                Failed to load buyer campaign data
              </h3>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <div>
        <div className="border-b border-lightgray">
          <nav className="-mb-px flex">
            <button
              onClick={() => setActiveTab("templates")}
              className={`${
                activeTab === "templates"
                  ? "border-black text-black"
                  : "border-transparent text-darkgray hover:text-darkgray hover:border-lightgray"
              } whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`}
            >
              Buyer Campaign Templates
            </button>
            <button
              onClick={() => setActiveTab("campaigns")}
              className={`${
                activeTab === "campaigns"
                  ? "border-black text-black"
                  : "border-transparent text-darkgray hover:text-darkgray hover:border-lightgray"
              } whitespace-nowrap py-4 px-6 border-b-2 font-medium text-sm`}
            >
              Buyer Campaigns
            </button>
          </nav>
        </div>
      </div>

      <div className="overflow-hidden">
        {activeTab === "templates" ? (
          <BuyerCampaignTemplates templates={templates} />
        ) : (
          <BuyerCampaigns campaigns={campaigns} templates={templates} />
        )}
      </div>
    </div>
  )
}

export default BuyerCampaignManagement
